import { Button } from 'antd';
import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { isUserManagedBySupplier } from '../../utils/AuthUtils';
import { withRouter } from 'react-router';

require('../permission_denied_page/PermissionDeniedPage.less');

const SupplierManagedBuyerPermissionChecker: FC<any> = ({
	children,
	currentUser,
	history,
}): React.ReactElement => {
	const isLocked = useMemo(() => isUserManagedBySupplier(currentUser), [currentUser]);

	const onSupportClick = () => window.Intercom && window.Intercom('show');

	const goBack = () => history.goBack();

	return isLocked ? (
		<div className="permissionDeniedPage">
			<img alt="" src="https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg" />
			<div className="permissionDeniedPage__textWrapper">
				<h3>Sorry! You don't have permission to view this content.</h3>
				<p>
					Click the button below to get back where you came from. If you need access to this
					resource, please contact an admin and request they grant you permission.
				</p>
				<div className="flex flex-row items-center">
					<Button type="ghost" size="large" onClick={goBack}>
						Go back
					</Button>
					<div className="ml-2">
						<Button type="primary" size="large" onClick={onSupportClick}>
							Contact Support
						</Button>
					</div>
				</div>
			</div>
		</div>
	) : (
		children
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default withRouter(connect(mapStateToProps)(SupplierManagedBuyerPermissionChecker));
